import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Loading } from '@rd-web-markets/shared/dist/util'
import { useGetUserClaimGroupAbilities } from '@rd-web-markets/market/dist/userAbilities'

const ClaimGroupListClientsViewReportButton = ({
	claimGroup,
	loading,
	accountType,
}) => {
	const { t } = useTranslation()
	const user = useSelector((state) => state.auth.user)
	const userClaimGroupAbilities = useGetUserClaimGroupAbilities({
		user,
		claimGroup,
		reviewedObject: claimGroup,
	})
	const pagesAccess = userClaimGroupAbilities?.pages
	const canViewReport = pagesAccess.MyClaimGroupsPage.components.ClaimGroupList.canAccessViewReport
	if (loading) return <Loading />

	if (!canViewReport || !claimGroup.report_template_rnd || !claimGroup.report_template_rnd.id) return <></>

	return (
		<Button
			size='md'
			className='claim-group-list-edit-button'
			as={Link}
			to={`/${accountType}/report_template/${claimGroup.report_template_rnd.id}`}
		>
			{t('view_report')}
		</Button>
	)
}

export default ClaimGroupListClientsViewReportButton
